"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseArtifactInstancePgId = exports.parseArtifactInstancePgColumn = void 0;
const consts_1 = __importDefault(require("../consts"));
const pgColumnIdenifierRegex = `^${consts_1.default.POSTGRES_COLUMN_MARKER}(.*)${consts_1.default.POSTGRES_ID_MARKER}.*$`;
const pgIdIdenifierRegex = `^${consts_1.default.POSTGRES_COLUMN_MARKER}.*${consts_1.default.POSTGRES_ID_MARKER}(.*)$`;
const parseArtifactInstancePgColumn = (identifier) => {
    const match = identifier.match(pgColumnIdenifierRegex);
    if (!match)
        return null;
    if (match.length !== 2)
        return null;
    return match[1];
};
exports.parseArtifactInstancePgColumn = parseArtifactInstancePgColumn;
const parseArtifactInstancePgId = (identifier) => {
    const match = identifier.match(pgIdIdenifierRegex);
    if (!match)
        return null;
    if (match.length !== 2)
        return null;
    return match[1];
};
exports.parseArtifactInstancePgId = parseArtifactInstancePgId;
//# sourceMappingURL=parse.js.map